// ---------------------------------------------------------------------------
// Detecção de navegador embutido (webview de apps como Instagram, Facebook,
// TikTok etc.). Esses apps abrem links por dentro deles mesmos e quebram
// várias coisas: senhas salvas, login com Google, etc.
// ---------------------------------------------------------------------------

const UA = navigator.userAgent || '';

export const ehInstagram = /Instagram/i.test(UA);
export const ehFacebook = /FBAN|FBAV|FB_IAB/i.test(UA);
export const ehTikTok = /BytedanceWebview|TikTok/i.test(UA);
export const ehOutroApp = /Line\/|Twitter|MicroMessenger|Snapchat/i.test(UA);
export const ehAppEmbutido = ehInstagram || ehFacebook || ehTikTok || ehOutroApp;

export const ehIOS = /iPhone|iPad|iPod/i.test(UA);
export const ehAndroid = /Android/i.test(UA);

// Instalado na tela de início (PWA)? Aí não há problema nenhum: não é webview.
export const ehAppInstalado =
  typeof window !== 'undefined' &&
  (window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as unknown as { standalone?: boolean }).standalone === true);

// iOS "de verdade" — cobre o iPhone/iPad pelo userAgent e também o iPad que se
// disfarça de computador (MacIntel + toque na tela).
export const ehIOSAparelho: boolean =
  /iPhone|iPad|iPod/i.test(UA) ||
  (typeof navigator !== 'undefined' &&
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints > 1);

// Safari de verdade no iOS: precisa ter "Safari" e "Version/" e NÃO pode ter
// nenhum outro navegador/app por cima (Chrome, Firefox, Edge, Instagram…).
const OUTROS_IOS =
  /CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|GSA\/|Instagram|FBAN|FBAV|FB_IAB|FBIOS|Line\/|WhatsApp|Snapchat|TikTok|musical_ly|Twitter|Pinterest|LinkedInApp|DuckDuckGo|YaBrowser/i;
export const ehSafariIOSDeVerdade: boolean =
  ehIOSAparelho && /Safari/i.test(UA) && /Version\//i.test(UA) && !OUTROS_IOS.test(UA);

// Android dentro de outro aplicativo (webview): o próprio aviso "; wv)" ou os
// apps que abrem o link por dentro deles (Instagram, Facebook, WhatsApp…).
export const ehAndroidAppInterno: boolean =
  /;\s*wv\)/i.test(UA) ||
  /Instagram|FBAN|FBAV|FB_IAB|Line\/|WhatsApp|TikTok|musical_ly|Snapchat/i.test(UA);

// Nome amigável do app, para as mensagens.
export function nomeDoApp(): string {
  if (ehInstagram) return 'Instagram';
  if (ehFacebook) return 'Facebook';
  if (ehTikTok) return 'TikTok';
  if (ehOutroApp) return 'outro aplicativo';
  return 'aplicativo';
}